export default {
	name: 'school-management',
	path: '/school-management',
	redirect: '/school-management/school',
	meta: {
		title: 'school_manager',
		icon: 'icon-school-management'
	},
	children: [
		{
			name: 'school',
			path: 'school',
			fullPath: '/school-management/school',
			meta: {
				title: 'school',
				icon: 'icon-school'
			},
			component: () =>
				import(/* webpackChunkName: "school" */ '@/views/school-management/school')
		},
		{
			name: 'staff',
			path: 'staff',
			fullPath: '/school-management/staff',
			meta: {
				title: 'staff',
				icon: 'icon-staff'
			},
			component: () =>
				import(/* webpackChunkName: "staff" */ '@/views/school-management/staff')
		},
		{
			name: 'class',
			path: 'class',
			fullPath: '/school-management/class',
			meta: {
				title: 'class',
				icon: 'icon-class'
			},
			component: () =>
				import(/* webpackChunkName: "class" */ '@/views/school-management/class')
		},
		{
			name: 'student',
			path: 'student',
			fullPath: '/school-management/student',
			meta: {
				title: 'student',
				icon: 'icon-student'
			},
			component: () =>
				import(/* webpackChunkName: "student" */ '@/views/school-management/student')
		},
		{
			name: 'parent',
			path: 'parent',
			fullPath: '/school-management/parent',
			meta: {
				title: 'parent',
				icon: 'icon-parent'
			},
			component: () =>
				import(/* webpackChunkName: "parent" */ '@/views/school-management/parent')
		},
		{
			name: 'course',
			path: 'course',
			fullPath: '/school-management/course',
			meta: {
				title: 'course',
				icon: 'icon-course'
			},
			component: () =>
				import(/* webpackChunkName: "course" */ '@/views/school-management/course')
		},
		{
			name: 'subject',
			path: 'subject',
			fullPath: '/school-management/subject',
			meta: {
				title: 'subject',
				icon: 'icon-subject'
			},
			component: () =>
				import(/* webpackChunkName: "subject" */ '@/views/school-management/subject')
		}
	]
};
